import React from "react";
import { AlertBanner, Text, TextLink } from "@origin-digital/ods-core";

export enum DismissableBannerType {
  HIDE,
  WARNING,
  ERROR,
}

export interface IDismissableBannerOptions {
  type: DismissableBannerType;
  message?: string;
  retryFn?: () => void;
}

export const DismissableBanner = (
  props: IDismissableBannerOptions & {
    setDismissableBannerOptions: (props: IDismissableBannerOptions) => void;
  }
) => {
  const { type, message, retryFn, setDismissableBannerOptions } = props;

  if (type === DismissableBannerType.HIDE) {
    return null;
  }

  const tone = type === DismissableBannerType.ERROR ? "critical" : "caution";

  return (
    <AlertBanner
      data-id="dismissable-banner"
      tone={tone}
      onCloseClick={() =>
        setDismissableBannerOptions({
          type: DismissableBannerType.HIDE,
        })
      }
    >
      <Text>
        {message}{" "}
        {retryFn && (
          <>
            Please{" "}
            <TextLink href="#" onClick={retryFn}>
              try again
            </TextLink>
          </>
        )}
      </Text>
    </AlertBanner>
  );
};
